module.exports = __webpack_public_path__ + "static/media/crow.dd1d8d97.svg";